module.exports = __webpack_public_path__ + "static/media/view assignment.33f38c54.svg";